import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import { Currency, Rate, RateTypes } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { RatesAddComponent } from './rates-add/rates-add.component';
import { RatesEditComponent } from './rates-edit/rates-edit.component';
import { StorageService } from 'src/app/services/storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-rates',
    templateUrl: './rates.component.html',
    styleUrls: ['./rates.component.sass'],
    standalone: false
})
export class RatesComponent implements OnInit {

  config?: IGenericCrudConfiguration<Rate>;

  currencies: Currency[];
  ratesTypes = RateTypes.map(r => ({ id: r.id, name: this.translationService.instant('entity.product.tabs.' + r.name) }));

  constructor(private api: MasterApiService, private storage: StorageService, private translationService: TranslateService) {
    this.currencies = [];
  }

  async ngOnInit(): Promise<void> {
    this.currencies = await firstValueFrom(this.storage.getCurrencies());

    this.config = {
      name: this.api.resources.master.rates.resourceName,
      resource: this.api.resources.master.rates,
      createComponent: RatesAddComponent,
      editComponent: {component: RatesEditComponent, inputPrms: {currencies: this.currencies, genericInfoAlternativeText: 'entity.price.rate'}} ,
      entityFields: {
        name: { isLink: true },
        typeId: {
          lookup: {
            dataSource: this.ratesTypes,
            displayExpr: 'name',
            valueExpr: 'id',
          }
        },
        currencyId: {
          lookup: {
            dataSource: this.currencies,
            displayExpr: 'name',
            valueExpr: 'id',
          }
        },
        'periodOfValidity.start': { dataType: 'date' },
        'periodOfValidity.end'  : { dataType: 'date' },
      },
      crudButtons: {
        canCreate: true,
        canEdit: true,
        canDelete: true,
      }
    };
  }
}

